import { TypeToColor } from "./consts.js";
import { ItemLocationKey } from "./enums.js";
import { GetTextColor, itemsJSON, movesJSON, WaitFetch } from "./helper.js";
import { ItemLocation } from "./interfaces.js";

var pageChanging = false;
var currPage = 0;

var pageTitles = [
	"Items - By Type",
	"Items - By Location",
];

$(window).on("load", async function () {
	await WaitFetch();

	currPage = parseInt(localStorage.getItem("ItemPage") ?? "0");
	$(`#title`).text(pageTitles[currPage]);
	$(`[data-page=${currPage}]`).css("display", "flex");

	$(".pageLeft").on("click", () => ChangePage(false));
	$(".pageRight").on("click", () => ChangePage(true));

	$(window).on("keyup", function (e) {
		if (pageChanging) return;

		if (e.key == "ArrowLeft")
			ChangePage(false);
		else if (e.key == "ArrowRight")
			ChangePage(true);
	});

	CreateItemTypeGrid();
	CreateItemLocGrid();

	ColorKeywords();
});

function ChangePage(pageRight: boolean) {
	if (pageChanging) return;

	pageChanging = true;
	$(`#title`).css("opacity", 0);

	$(`[data-page=${currPage}]`).fadeOut(250, () => GetNewPage(currPage, pageRight));
}

function GetNewPage(pageNum: number, pageRight: boolean) {
	if (pageRight)	pageNum++;
	else						pageNum--;

	if (pageNum < 0 ) pageNum += pageTitles.length;
	pageNum = pageNum % pageTitles.length;

	$(`#title`).text(pageTitles[pageNum]);
	$(`#title`).css("opacity", 100);

	$(`[data-page=${pageNum}]`).fadeIn(250).css("display", "flex");

	currPage = pageNum;
	localStorage.setItem("ItemPage", String(currPage));
	pageChanging = false;
}

function CreateItemTypeGrid() {
	interface LocalItem {
		Name: string;
		SubCat: string;
		Desc: string;
		Changes?: string;
		Locations: Record<ItemLocationKey, Array<ItemLocation>>;
	}

	let sections: Record<string, Array<LocalItem>> = {};

	Object.entries(itemsJSON!).forEach(([item, info]) => {
		if (!(info.Category in sections))
			sections[info.Category] = [];

		let localItem: LocalItem = {
			Name: item,
			SubCat: info.Subcategory,
			Desc: info.Description,
			Changes: info.Changes,
			Locations: info.Locations
		};

		sections[info.Category].push(localItem);
	});

	Object.entries(sections).forEach(([section, items]) => {
		let $sectionGrid = $("<div>", { class: "sectionGrid byType" })
			.append($("<div>", { class: "col topLeft" }))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Item" })))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Description" })))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Locations\n(Mart)" })))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Locations\n(Pickup)" })))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Locations\n(NPC)" })))
			.append($("<div>", { class: "col topRight" }).append($("<h4>", { text: "Changes" })));

		items.forEach((item, idx) => {
			let iconName = item.Name.toLowerCase();

			if (section == "TM/HM") {
				let move = item.Desc;
				let type = movesJSON![move].Type;

				iconName = `tm ${type}`.toLowerCase();
			}

			let $icon = $("<div>", { class: `col ${idx == items.length - 1 ? "botLeft" : ""}` }).append($("<img>", { src: `images/items/${iconName}.png` }));
			let $name = $("<div>", { class: `col` }).append($("<p>", { text: item.Name }));
			let $desc = $("<div>", { class: "col" }).append($("<p>", { text: item.Desc }));

			let locMart: Array<string> = [];
			let locPickup: Array<string> = [];
			let locNPC: Array<string> = [];

			if (ItemLocationKey.Mart in item.Locations) {
				item.Locations.Mart.forEach(locDetails => {
					let str = locDetails.Location;

					if (locDetails.Location == "General Mart")
						str += `\n(${locDetails.Details})`;

					locMart.push(str);
				});
			}

			if (ItemLocationKey.Pickup in item.Locations) {
				item.Locations.Pickup.forEach(locDetails => {
					let str = locDetails.Location;
					
					if ((section != "Held" && section != "TM/HM") || item.Name == "Berry Juice")
						str += ` (x${locDetails.Quantity ?? "1"})`;

					locPickup.push(str);
				});
			}

			if (ItemLocationKey.NPC in item.Locations) {
				item.Locations.NPC.forEach(locDetails => {
					let str = locDetails.Location;
					
					if ((section != "Held" && section != "TM/HM") || item.Name == "Berry Juice")
						str += ` (x${locDetails.Quantity ?? "1"})`;

					locNPC.push(str);
				});
			}
			
			let $locMart = $("<div>", { class: "col" }).append($("<p>", { text: locMart.length != 0 ? locMart.join("\n") : "-" }));
			let $locPickup = $("<div>", { class: "col" }).append($("<p>", { text: locPickup.length != 0 ? locPickup.join("\n") : "-" }));
			let $locNPC = $("<div>", { class: "col" }).append($("<p>", { text: locNPC.length != 0 ? locNPC.join("\n") : "-" }));

			let $changes = $("<div>", { class: `col ${idx == items.length - 1 ? "botRight" : ""}` }).append($("<p>", { text: item.Changes ?? "" }));

			if (idx + 1 != items.length && item.SubCat != items[idx + 1].SubCat) {
				$icon.addClass("newSubCat");
				$name.addClass("newSubCat");
				$desc.addClass("newSubCat");
				$locMart.addClass("newSubCat");
				$locPickup.addClass("newSubCat");
				$locNPC.addClass("newSubCat");
				$changes.addClass("newSubCat");
			}

			if (section != "TM/HM") {
				$desc.addClass("highlight");
				$changes.addClass("highlight");
			}
			else {
				let move = item.Desc;
				let type = movesJSON![move].Type;
				let textColor = GetTextColor(type);

				let hexColor = TypeToColor[type];
				let r = parseInt(hexColor.slice(1, 3), 16);
				let g = parseInt(hexColor.slice(3, 5), 16);
				let b = parseInt(hexColor.slice(5), 16);

				$desc.css("background-color", `rgba(${r}, ${g}, ${b}, 0.75)`);
				$desc.children("p").css("color", textColor);

				if (textColor == "#eee")
					$desc.children("p").css("text-shadow", "0px 0px 4px #000");
			}

			if (ItemLocationKey.Mart in item.Locations)
				$locMart.addClass("mart");
			if (ItemLocationKey.Pickup in item.Locations)
				$locPickup.addClass("pickup");
			if (ItemLocationKey.NPC in item.Locations)
				$locNPC.addClass("npc");

			$sectionGrid.append($icon);
			$sectionGrid.append($name);
			$sectionGrid.append($desc);
			$sectionGrid.append($locMart);
			$sectionGrid.append($locPickup);
			$sectionGrid.append($locNPC);
			$sectionGrid.append($changes);
		});

		let $append = $("<div>", {
			class: "sectionWrapper"
		}).append($("<h1>", {
			text: section
		})).append($sectionGrid);

		$("#byType").append($append);
	});
}

function CreateItemLocGrid() {
	interface LocalItem {
		Name: string;
		Desc: string;
		Category: string;
		Quantity?: number;
		Cost?: number;
		Details: string;
		Type: ItemLocationKey;
	}

	interface LocInfo {
		LocIdx: number;
		Items: Array<LocalItem>;
	}

	let locations: Record<string, LocInfo> = {};

	Object.entries(itemsJSON!).forEach(([item, info]) => {
		Object.entries(info.Locations).forEach(([type, locDetails]) => {
			locDetails.forEach(details => {
				if (details.Location.startsWith("Held Item"))
					return;

				if (!(details.Location in locations))
					locations[details.Location] = {
						LocIdx: -1,
						Items: []
					};
				
				let localItem: LocalItem = {
					Name: item,
					Desc: info.Description,
					Category: info.Category,
					Quantity: details.Quantity,
					Cost: details.Cost,
					Details: details.Details,
					Type: type as ItemLocationKey
				};

				if (details.LocIdx != undefined)
					locations[details.Location].LocIdx = details.LocIdx;

				locations[details.Location].Items.push(localItem);
			});
		});
	});

	let locationsSorted = Object.entries(locations).sort(([_a, infoA], [_b, infoB]) => infoA.LocIdx - infoB.LocIdx);

	locationsSorted.forEach(([loc, locInfo]) => {
		locInfo.Items.sort((a, b) => {
			if (a.Type == ItemLocationKey.Mart && b.Type == ItemLocationKey.Mart) {
				if (loc == "General Mart")
					return 0;
				else
					return a.Details.localeCompare(b.Details);
			}

			if (a.Type == ItemLocationKey.Mart)
				return 1;
			
			if (b.Type == ItemLocationKey.Mart)
				return -1;

			return 0;
		});
	});

	locationsSorted.forEach(([loc, locInfo]) => {
		let $sectionGrid = $("<div>", { class: "sectionGrid byLoc" })
			.append($("<div>", { class: "col topLeft" }))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Item" })))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Category" })))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Quantity" })))
			.append($("<div>", { class: "col" }).append($("<h4>", { text: "Cost" })))
			.append($("<div>", { class: "col topRight" }).append($("<h4>", { text: "Location Details" })));

		locInfo.Items.forEach((item, idx) => {
			let iconName = item.Name.toLowerCase();

			if (item.Category == "TM/HM") {
				let move = item.Desc;
				let type = movesJSON![move].Type;

				iconName = `tm ${type}`.toLowerCase();
			}

			let $icon = $("<div>", { class: `col ${idx == locInfo.Items.length - 1 ? "botLeft" : ""}` }).append($("<img>", { src: `images/items/${iconName}.png` }));
			let $name = $("<div>", { class: `col` }).append($("<p>", { text: item.Category == "TM/HM" ? `${item.Name} ${item.Desc}` : item.Name }));
			let $category = $("<div>", { class: "col" }).append($("<p>", { text: item.Category }));
			let $quantity = $("<div>", { class: "col" }).append($("<p>", { text: item.Quantity != undefined ? (item.Quantity == 0 ? "∞" : item.Quantity) : "1" }));
			let $cost = $("<div>", { class: "col" }).append($("<p>", { text: item.Cost != undefined ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(item.Cost) : "-" }));
			let $details = $("<div>", { class: `col ${idx == locInfo.Items.length - 1 ? "botRight" : ""}` }).append($("<p>", { text: item.Details }));

			$details.addClass(item.Type.toLowerCase());

			$sectionGrid.append($icon);
			$sectionGrid.append($name);
			$sectionGrid.append($category);
			$sectionGrid.append($quantity);
			$sectionGrid.append($cost);
			$sectionGrid.append($details);
		});

		let $append = $("<div>", {
			class: "sectionWrapper"
		}).append($("<h1>", {
			text: loc
		})).append($sectionGrid);

		$("#byLoc").append($append);
	});
}

function ColorKeywords() {
	let colorRanges: Record<string, Array<Range>> = {
		Number: [],
		Normal: [],
		Fire: [],
		Water: [],
		Electric: [],
		Grass: [],
		Ice: [],
		Fighting: [],
		Poison: [],
		Ground: [],
		Flying: [],
		Psychic: [],
		Bug: [],
		Rock: [],
		Ghost: [],
		Dragon: [],
		Steel: [],
		Dark: [],
		Fairy: [],
		HP: [],
		Atk: [],
		Def: [],
		SpA: [],
		SpD: [],
		Spe: [],
	};

	$(".col p").each((_, el) => {
		const textNodes = Array.from(el.childNodes).filter(node => node.nodeType == Node.TEXT_NODE);
		
		textNodes.forEach(node => {
			let text = node.textContent!;

			Object.keys(colorRanges).forEach(keyword => {
				let searchTerms = [keyword];

				if (keyword == "Dark") {
					searchTerms.push("sleep");
					searchTerms.push("asleep");
				}
				else if (keyword == "Electric") {
					searchTerms.push("paralyze");
					searchTerms.push("paralysis");
				}
				else if (keyword == "Fire") {
					searchTerms.push("burn");
					searchTerms.push("harsh sunlight");
					searchTerms.push("Sunny Day");
					searchTerms.push("Drought");
				}
				else if (keyword == "Grass") {
					searchTerms.push("Leech Seed");
					searchTerms.push("Ingrain");
					searchTerms.push("powder");
					searchTerms.push("spore");
				}
				else if (keyword == "Ice") {
					searchTerms.push("hail");
				}
				else if (keyword == "Normal") {
					searchTerms.push("flinch");
				}
				else if (keyword == "Poison") {
					searchTerms.push("poison");
					searchTerms.push("badly poisoned")
				}
				else if (keyword == "Psychic") {
					searchTerms.push("fatigue");
					searchTerms.push("confus");
					searchTerms.push("Reflect");
					searchTerms.push("Light Screen");
					searchTerms.push("Trick Room");
				}
				else if (keyword == "Rock") {
					searchTerms.push("sandstorm");
					searchTerms.push("Sandstorm");
					searchTerms.push("Sand Stream");
				}
				else if (keyword == "Water") {
					searchTerms.push("rain");
					searchTerms.push("Rain Dance");
					searchTerms.push("Drizzle");
					searchTerms.push("Aqua Ring");
				}

				else if (keyword == "Atk")
					searchTerms.push("Attack");
				else if (keyword == "Def")
					searchTerms.push("Defense");
				else if (keyword == "SpA")
					searchTerms.push("Special Attack");
				else if (keyword == "SpD")
					searchTerms.push("Special Defense");

				searchTerms.forEach(term => {
					let regex, match;
					if (term == "Number")
						regex = new RegExp(/[+-]?\d+(?:\.\d+)?(?:\s*→\s*)?\d*(?:\.\d+)?[%x]?/, "g");
					else
						regex = new RegExp(`\\b${term}[edingo]*\\b`, "g");

					while ((match = regex.exec(text)) != null) {
						let range = new Range();
						range.setStart(node, match.index);
						range.setEnd(node, match.index + match[0].length);

						colorRanges[keyword].push(range);

						if (match.index == regex.lastIndex)
							regex.lastIndex++;
					}
				});
			});
		});
	});

	Object.entries(colorRanges).forEach(([keyword, rangeList]) => {
		CSS.highlights.set(keyword, new Highlight(...rangeList));
	});
}